
import React from 'react';

export const EyeIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    visibility
  </span>
);